import { doc, serverTimestamp, setDoc, getDoc, collection, query, where, getDocs } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { db } from "./firebase";
import { getBrowser, getUnixTime, setDeviceType } from "./util";

export const userLogging = (functionName: String, content: Object, user: any) => {
    const jsonUserData = JSON.parse(user.userData);
    const screen = `縦:${window.innerHeight}px 横:${window.innerWidth}px`;
    const data: any = {
        access_time_unixtime: getUnixTime(),
        application_name: "location",
        user_name: jsonUserData.email,
        function_name: functionName,
        content: content,
        device: setDeviceType(),
        screen,
        browser: getBrowser(),
        update_date: {
            update_date: serverTimestamp(),
            update_user: jsonUserData.email,
        },
    };
    writeFirestoreDoc("users_log", uuidv4(), data);
};

/**
 * firestoreに書き込みを行う
 */
const writeFirestoreDoc = (collectionName: string, docId: string, data: any) => {
    try {
        setDoc(doc(db, collectionName, docId), data);
    } catch (error) {
        console.log(error);
    }
};

/**
 * 依頼コメント画面 パターンの項目値によてパターン詳細のプルダウンの項目値を取得
 */
export const getPatternDetails  = async (pattern: string): Promise<any[]> => {
    try {
        const patternsData = await readFirestoreDoc("code_master", "link_master", "pattern-pattern_details");
        if (patternsData) {
            const patternDetailsData = patternsData.pattern.find((patternRow: any) => patternRow.code_value === pattern);
            if (patternDetailsData) {
                return patternDetailsData.pattern_details;
            } else {
                return [];
            }
        }
    } catch (e) {
        console.error(e);
    }
    return [];
};

/**
 * 特別なユーザーか判定
 */
export const getLocationAdminUserCheck = async (uid: string): Promise<boolean> => {
    try {
        const locationAdminList = await readFirestoreDoc("code_master", "location_admin", "uid");
        if (locationAdminList.length > 0) {
            // ログインしたユーザーのuidがcode_masterコレクションのlocation_adminドキュメントにuidが含まれているか判定
            return locationAdminList.includes(uid);
        } else {
            return false;
        }
    } catch (e) {
        console.error(e);
        return false;
    }
}

/**
 * ユーザー切り替え
 */
export const getChangeLocationUser = async (staffNumber: string): Promise<any| null> => {
    let uid = "";
    try {
        const q = query(collection(db, "users"), where("staff_number", "==", staffNumber));
        const querySnapshot = await getDocs(q);
        const result: any[] = [];
        querySnapshot.forEach((doc) => {
            result.push({ id: doc.id, ...doc.data() });
        });
        // ユーザーは1人しか存在しない
        if (result.length === 1) {
            return result[0];
        } else {
            return null;
        }
    } catch (e) {
        console.error(e);
        return null;
    }
}

/**
 * firestoreから読み込み
 */
export const readFirestoreDoc = async (collectionName: string, docName: string, fieldName: string) => {

    try {
        const docRef = doc(db, collectionName, docName);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data()[fieldName]; // 取得したフィールドの値を返す
        } else {
            console.log("No such document");
        }
    } catch (e) {
        console.error(e);
    }
};